<div class="quote-progress__card" data-testid="quote-cost-card">
  <div class="quote-progress__info">
    <div class="quote-progress__info-col">
      <span class="quote-progress__info-label">Delivery type</span>
      <span class="quote-progress__info-value">
        <mat-icon
          class="quote-progress__clock-icon"
          [svgIcon]="deliveryType() === 'Rushed' ? 'bolt' : 'pace'"
          aria-hidden="true"
        ></mat-icon>
        {{ deliveryType() }}
      </span>
    </div>
    <div class="quote-progress__info-col">
      <span class="quote-progress__info-label">Delivery date</span>
      <span class="quote-progress__info-value quote-progress__info-value--bold">
        {{ deliveryDate() }}
      </span>
    </div>
    <div class="quote-progress__info-col">
      <span class="quote-progress__info-label">Quote ID</span>
      <span class="quote-progress__info-value quote-progress__info-value--bold">
        {{ quoteId() }}
      </span>
    </div>
  </div>

  @if (!summaryOnly() && costBreakdown().length) {
    <div class="quote-progress__breakdown">
      @for (item of costBreakdown(); track item.concept) {
        <div class="quote-progress__breakdown-row">
          <span class="quote-progress__breakdown-concept">
            {{
              item.concept === "Translation cost"
                ? "Estimated linguistic review"
                : item.concept
            }}
          </span>
          <span class="quote-progress__breakdown-values">
            @if (getCostDelta(item.concept); as delta) {
              <span
                class="quote-progress__breakdown-delta"
                data-testid="quote-cost-delta"
              >
                +{{ delta.toFixed(2) }}
              </span>
            }
            <span class="quote-progress__breakdown-cost">
              {{ item.cost | formatCurrency: currency() }}
            </span>
          </span>
        </div>
      }
      <div class="quote-progress__total-row">
        <span class="quote-progress__total-label">Total cost</span>
        <span class="quote-progress__total-value">
          {{ totalCost() | formatCurrency: currency() }}
        </span>
      </div>
    </div>
  } @else if (summaryOnly()) {
    <div
      class="quote-progress__total-row quote-progress__total-row--summary"
      data-testid="quote-cost-summary-total"
    >
      <span class="quote-progress__total-label">Total cost</span>
      <span class="quote-progress__total-value">
        {{ totalCost() | formatCurrency: currency() }}
      </span>
    </div>
  }

  @if (recommendedPOTotal() !== null) {
    <p class="quote-progress__buffer-note">
      <strong>Note:</strong> Add a 15% buffer to your purchase order to account
      for potential adjustments in currency, tax, or review costs after file
      preparation.
    </p>

    <div class="quote-progress__recommended">
      <span class="quote-progress__recommended-label"
        >Recommended PO total</span
      >
      <span class="quote-progress__recommended-value">
        <span class="quote-progress__recommended-pct">+15%</span>=
        {{ recommendedPOTotal()! | formatCurrency: currency() }}
      </span>
    </div>
  }
</div>
